import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import Select from "react-select";
import { Link, NavLink, useParams } from "react-router-dom";
import { handleDownloadOptions } from "../../Components/ExportData";

const AllItemRequests = () => {
    const { project_id, status } = useParams()
    const { apiURL, apiHeaderJson, apiHeaderFile, user_profile_id } = useContext(ConfigContext);
    const [selectOption, setSelectOption] = useState(null);
    const [rows, setRows] = useState([]);
    const [requestStatus, setRequestStatus] = useState(null);
    const [prev, setPrev] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [next, setNext] = useState(false);
    const [page, setPage] = useState(1);
    const [reload, setReload] = useState(false)
    const [item_id, setItemId] = useState(0)
    const [item_row, setItemRow] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState(null);
    const [projectData, setProjectData] = useState([]);
    const [formData, setFormData] = useState({
        title: "",
        consultant: "",
        project: "",
        contractor: "",
        submittalType: "",
        description: "",
        submittedBy: { name: "", position: "" },
        consultantRevision: "",
        attachments: [],
        approvalStatus: "",
        refNumber: "",
        title: "",
        revisionNumber: "",
        date: "",
        approvals: { name: "", position: "", date: "" },
        clearances: {
            electrical: false,
            architecture: false,
            civil: false,
            mechanical: false,
            digitalSignature: false,
            comments: ""
        },
    })

    const [attachments, setAttachments] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState(0);
    const [submittalDescription, setSubmittalDescription] = useState("");
    const [briefDescription, setBriefDescription] = useState("");
    const [inspectionRequired, setInspectionRequired] = useState(0);
    const [loadingList, setLoadingList] = useState(false);
    const [inspectionFormID, setinspectionFormID] = useState(0);
    const [projectRequestId, setProjectRequestId] = useState(0);
    const [consultantData, setConsultantData] = useState([]);
    const [consultantId, setConsultantId] = useState(0);

    const options = [
        { value: 'pending', label: "Pending" },
        { value: 'approved', label: 'Approved' },
        { value: 'rejected', label: 'Rejected' }
    ];
    const submittalOptions = [
        "Sub-contractor pre-qualification",
        "Material & product data",
        "Method statement",
        "Design calculation",
        "Request for information",
        "Testing and commissioning",
        "Inspection request",
    ];

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFormData((prevData) => ({
            ...prevData,
            attachments: [...prevData.attachments, ...selectedFiles]
        }));

        setAttachments((prevFiles) => [...prevFiles, ...selectedFiles]);
        e.target.value = "";
    };

    const handleRemoveFile = (index) => {
        setFormData((prevData) => ({
            ...prevData,
            attachments: prevData.attachments.filter((_, i) => i !== index)
        }));

        setAttachments((prevFiles) =>
            prevFiles.filter((_, i) => i !== index)
        );
    };

    const handleSelectStatus = (selectedOption) => {
        setSelectOption(selectedOption ? selectedOption.value : '');
    };

    const handleSelect = (selectedOption) => {
        setItemId(selectedOption ? selectedOption.value : null);
        setSelectedItemId(selectedOption ? selectedOption.value : null);
        setSelectedOptions(selectedOption);
    };

    const handleConsuntantSelect = (selectOption) => {
        setConsultantId(selectOption ? selectOption.value : null);
    };

    const getProjectConsultant = async () => {
        try {
            const response = await axios.get(`${apiURL}api/project-consultants/project/${project_id}`);
            const { data, success } = response.data;
            if (success === true) {
                setConsultantData(
                    data.map((row) => ({
                        value: row.consultant_id,
                        label: row.profile_name
                    }))
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    const Labels = (status) => {
        if (status === 0) {
            return "Pending"
        }
        else if (status === 1) {
            return "Approved"
        }
        else if (status === 2) {
            return "Revise"
        }
        else if (status === 3) {
            return "Rejected"
        }
        else if (status === 4) {
            return "In-Clearence"
        }
    }

    const Classes = (status) => {
        if (status === 0) {
            return "badge bg-warning-subtle text-warning"
        }
        else if (status === 1) {
            return "badge bg-success-subtle text-success"
        }
        else if (status === 2) {
            return "badge bg-info-subtle text-info"
        }
        else if (status === 3) {
            return "badge bg-danger-subtle text-danger"
        }
        else if (status === 4) {
            return "badge bg-secondary-subtle text-secondary"
        }
    }

    const AcceptRejectRequest = (actionType) => {
        Swal.fire({
            title: `Submit Remark for ${actionType}`,
            input: 'text',
            inputPlaceholder: 'Enter your Remark',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            cancelButtonText: 'Cancel',
            inputValidator: (value) => {
                if (!value) {
                    return 'Remark cannot be empty';
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    icon: 'success',
                    title: 'Remark successfully submitted',
                    showConfirmButton: false,
                    timer: 1500,
                }).then(() => {
                    if (actionType === 'Accept') {
                        setRequestStatus('approved');
                    } else if (actionType === 'Cancel') {
                        setRequestStatus('rejected');
                    }
                });
            }
        });
    };

    const handlePrev = () => {
        if (prev) {
            setPage((prevPage) => prevPage - 1);
        }
    };

    const handleNext = () => {
        if (next) {
            setPage((prevPage) => prevPage + 1);
        }
    };
    const handleChange = (e) => {
        setPage(parseInt(e.target.value, 10));
    };

    const GetAllRequests = async () => {
        try {
            setLoadingList(true)
            const headers = apiHeaderJson;
            const response = await axios.get(
                `${apiURL}api/GetDashboardForContractor`,
                {
                    params: { contractor_id: user_profile_id },
                    headers,
                }
            );
            const data = response.data;

            if (data.success) {
                setRows(response.data?.data?.tabs?.projects_requests.filter((row) => Number(row?.project_id) === Number(project_id)))
                setNext(data.next);
                setPrev(data.prev);
                setTotalRecords(data.total_records);
                setTotalPages(data.total_pages);
                setReload(false);
            }
        } catch (error) {
            console.log("error while fetching data", error);
        }
        finally {
            setLoadingList(false)
        }
    }

    const GetProjectData = async () => {
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/contractors/projects/${user_profile_id}`, {
                headers,
            })

            const { data, success } = response.data;
            if (success) {
                setProjectData(data.map((row) => ({
                    value: row.project_id,
                    label: row.project_title
                })))
            }
        } catch (error) {
            console.log("Error while fetching data", error);
        }
    }

    const GetItemList = async () => {
        try {
            const headers = apiHeaderJson
            const response = await axios.get(`${apiURL}api/requests/GetProjectItems`, { params: { project_id, limit: 10000 } })
            const { data, success } = response.data;
            if (success) {
                setItemRow(data.map((row) => ({
                    value: row.project_item_id,
                    label: row.item_name,
                })))
            }
            else {
                setItemRow([])
            }
        } catch (error) {
            console.log("Error while fetching data", error);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();

            if (projectRequestId) {
                formData.append('project_request_id', projectRequestId);
            }
            formData.append('project_id', project_id);
            formData.append('inspection_id', inspectionFormID);
            formData.append('consultant_id', consultantId)
            formData.append('project_item_id', selectedItemId);
            formData.append('contractor_id', user_profile_id);
            formData.append('submittal_description', submittalDescription);
            formData.append('request_brief_description', briefDescription);
            formData.append('required_inspection', inspectionRequired);

            attachments.forEach((file) => {
                formData.append('attachments[]', file);
            });

            const response = await axios.post(
                `${apiURL}api/requests/PostProjectRequest`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            );

            const { success } = response.data;
            Swal.fire({
                title: `<strong>${success ? "Success" : "Failed"}</strong>`,
                text: response.data.message,
                icon: success ? "success" : "error",
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
            });

            if (success) {
                resetForm();
                document.getElementById('btn-close-model').click();
                GetAllRequests()
            }
        } catch (error) {
            console.error('Error submitting request:', error);
            Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Failed to submit request',
                icon: 'error',
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
            });
        }
    };

    const handleDownload = (downloadType) => {
        const endpoint = `api/GetDashboardForContractor`;
        const params = {
            contractor_id: user_profile_id
        };

        const columns = [
            { header: "Project Name", width: 30 },
            { header: "Item Name", width: 35 },
            { header: "Submittal Description", width: 27 },
            { header: "Brief Description", width: 30 },
            { header: "Location", width: 30 },
            { header: "Status", width: 25 },
        ];

        const mapRow = (data) => ({
            "Project Name": data?.project_title ?? '-',
            "Item Name": data?.item_name ?? '-',
            "Submittal Description": data?.submittal_description ?? "-",
            "Brief Description": data?.request_brief_description ?? "-",
            "Location": data?.project_address ?? "-",
            "Status": Labels(data?.request_status) ?? "-",
        });

        const responseHandler = (response) => response.data?.data?.tabs?.projects_requests || [];

        handleDownloadOptions(endpoint, params, columns, mapRow, downloadType, apiURL, apiHeaderJson, responseHandler);
    };

    const updateRequest = async (id) => {
        const headers = apiHeaderJson
        const Body = {
            project_request_id: id
        }
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: 'You want to resubmit the request!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Resubmit it!'
        });
        if (confirm.isConfirmed) {
            try {
                const response = await axios.post(`${apiURL}api/requests/ResubmitRequest`, Body, { headers });
                const { success } = response.data;
                if (success === true) {
                    Swal.fire({
                        title: `<strong>${response.data.success ? "Success" : "Failed"}</strong>`,
                        text: response.data.message,
                        icon: response.data.success ? "success" : "error",
                        timer: 1000,
                        timerProgressBar: true,
                        showConfirmButton: false,
                    });
                    GetAllRequests();
                }
            } catch (error) {
                console.error(error);
                Swal.fire(
                    'Error!',
                    'Something went wrong while Updating.',
                    'error'
                );
            }
        }
    }

    const handleEditRequest = async (row) => {
        setProjectRequestId(row?.project_request_id || 0);
        setinspectionFormID(row?.inspection_id || 0);
        setSelectedItemId(row?.project_item_id || 0);
        setItemId(row?.project_item_id || 0);
        setSubmittalDescription(row?.submittal_description || "");
        setBriefDescription(row?.request_brief_description || "");
        setConsultantId(row?.consultant_id || 0);
        setInspectionRequired(Number(row?.required_inspection || 0));

        const modal = document.getElementById("myModal");
        const bsModal = new window.bootstrap.Modal(modal);
        bsModal.show();
    };

    const resetForm = () => {
        setFormData((prev) => ({ ...prev, attachments: [] }));
        setAttachments([]);
        setProjectRequestId(0);
        setItemId(0);
        setBriefDescription("");
        setSubmittalDescription("");
        setinspectionFormID(0);
        setConsultantId(0);
        setInspectionRequired(0);
    };

    useEffect(() => {
        GetAllRequests()
        GetProjectData()
    }, [project_id])

    useEffect(() => {
        project_id && getProjectConsultant();
        project_id && GetItemList();
    }, [project_id])

    return (
        <div className="col-xxl-12">
            <div className="card">
                {
                    loadingList ? <ContentLoader /> :
                        <div className="card-body">
                            <div className="card-header d-flex align-items-center mb-4">
                                <h5 className="card-title flex-grow-1 mb-0">Item Requests</h5>
                                {
                                    status === '0' && (
                                        <div className="flex-shrink-0">
                                            <button
                                                type="button"
                                                data-bs-toggle="modal"
                                                data-bs-target="#myModal"
                                                onClick={() => getProjectConsultant()}
                                                htmlFor="addRequest"
                                                className="btn btn-warning"
                                            >
                                                <i className="ri-add-circle-line me-1 align-bottom" /> Add Request
                                            </button>
                                        </div>
                                    )}
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="table-responsive">
                                        <table className="table table-borderless align-middle mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="text-center" width="25%">Project Name</th>
                                                    <th className="text-center" width="10%">Item Name</th>
                                                    <th className="text-center" width="25%">Submittal Description</th>
                                                    <th className="text-center" width="25%">Brief Description</th>
                                                    <th className="text-center" width="25%">Location</th>
                                                    <th className="text-center" width="10%">Revision Count</th>
                                                    <th className="text-center" width="20%">Status</th>
                                                    <th className="text-center" width="15%">Action</th>
                                                </tr>
                                            </thead>

                                            {rows.length !== 0 ? (
                                                <tbody>
                                                    {
                                                        rows.map((row) => (
                                                            <tr key={row.project_request_id}>
                                                                <td className="text-center"><NavLink to={`/ProjectProfile/${row.project_id}`}>{row?.project_title ?? '-'}</NavLink></td>
                                                                <td className="text-center">{row?.item_name ?? '-'}</td>
                                                                <td className="text-center">{row?.submittal_description ?? '-'}</td>
                                                                <td className="text-center">{row?.request_brief_description ?? '-'}</td>
                                                                <td className="text-center">{row?.project_address}</td>
                                                                <td className="text-center">{row?.request_revision_count}</td>
                                                                <td className="text-center"><span className={Classes(row.request_status)}>{Labels(row.request_status)}</span></td>

                                                                <td className="d-flex justify-content-around mt-2">
                                                                    {/* View Button - Always visible */}
                                                                    <Link to={`/PreviewStatus/${row?.project_request_id}`}>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-link text-info fs-18 p-0"
                                                                        >
                                                                            <i className="ri-eye-line" />
                                                                        </button>
                                                                    </Link>

                                                                    {status === '0' && (
                                                                        <>
                                                                            {/* Resubmit Button - For Revise (2) or Rejected (3) statuses */}
                                                                            {(row.request_status === 2 || row.request_status === 3) && (
                                                                                <>
                                                                                    <button
                                                                                        onClick={() => handleEditRequest(row)}
                                                                                        type="button"
                                                                                        className="btn btn-link text-warning"
                                                                                    >
                                                                                        <i className="ri-edit-line"></i>
                                                                                    </button>

                                                                                    <button
                                                                                        onClick={() => updateRequest(row?.project_request_id)}
                                                                                        type="button"
                                                                                        className="btn btn-soft-info btn-border fs-10 mx-1"
                                                                                    >
                                                                                        Resubmit
                                                                                    </button>
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="8">
                                                            <NoRecords />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                }

                <div
                    id="myModal"
                    className="modal fade"
                    tabIndex={-1}
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                    style={{ display: "none" }}
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myModalLabel">
                                    Request For New Item
                                </h5>
                                <button
                                    type="button"
                                    id="btn-close-model"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => resetForm()}
                                >
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="">
                                        <div className="card shadow-none">
                                            <div className="row gy-4">
                                                <div className="col-md-12">
                                                    <form onSubmit={handleSubmit} className="row">
                                                        <div className="col-md-12 mt-3">
                                                            <Select
                                                                onChange={handleSelect}
                                                                options={item_row}
                                                                placeholder=" Select Item"
                                                                id="setItemError"
                                                                value={item_id ? item_row.find((option) => option.value === item_id) : null}
                                                            />
                                                        </div>
                                                        <div className="col-md-12 mt-3">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <Select
                                                                        options={submittalOptions.map(option => ({ value: option, label: option }))}
                                                                        onChange={(selectedOption) => setSubmittalDescription(selectedOption.value)}
                                                                        value={{ value: submittalDescription, label: submittalDescription || "Type of Submittal" }}
                                                                        placeholder="Type of Submittal"
                                                                        className="basic-select"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Commented out form selection dropdown */}
                                                        {/* <div className="col-md-12 mt-3">
                                                            <Select
                                                                onChange={handleFormSelect}
                                                                options={inspectionFormData}
                                                                placeholder="Select Form"
                                                                value={inspectionFormID ? inspectionFormData.find(opt => opt.value === inspectionFormID) : null}
                                                            />
                                                        </div> */}

                                                        <div className="col-md-12 mt-3">
                                                            <Select
                                                                onChange={handleConsuntantSelect}
                                                                options={consultantData}
                                                                placeholder="Select Consultant"
                                                                value={consultantId ? consultantData.find(opt => opt.value === consultantId) : null}
                                                            />
                                                        </div>
                                                        <div className="col-md-12 mt-3">
                                                            <div className="row">
                                                                <div className="col-md-10">
                                                                    <input
                                                                        type="file"
                                                                        multiple
                                                                        className="form-control"
                                                                        onChange={handleFileChange}
                                                                    />
                                                                </div>
                                                                <div className="col-md-2 d-flex justify-content-center align-items-center">
                                                                    <input
                                                                        type="file"
                                                                        id="additionalFileInput"
                                                                        multiple
                                                                        className="d-none"
                                                                        onChange={handleFileChange}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success btn-sm"
                                                                        onClick={() => document.getElementById('additionalFileInput').click()}
                                                                    >
                                                                        <i className="ri-add-circle-line fs-15"></i>
                                                                    </button>
                                                                </div>
                                                            </div>

                                                            {formData.attachments.length > 0 && (
                                                                <div className="mt-3 border border p-3 rounded bg-white">
                                                                    <h6>Uploaded Files:</h6>
                                                                    <ul className="list-group">
                                                                        {formData.attachments.map((file, index) => (
                                                                            <li
                                                                                key={index}
                                                                                className="list-group-item d-flex justify-content-between align-items-center"
                                                                            >
                                                                                <span>{file.name}</span>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-danger btn-sm"
                                                                                    onClick={() => handleRemoveFile(index)}
                                                                                >
                                                                                    <i className="ri-delete-bin-line"></i>
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="col-md-12 mt-3">
                                                            <textarea
                                                                id="briefDescription"
                                                                name="briefDescription"
                                                                value={briefDescription}
                                                                onChange={(e) => setBriefDescription(e.target.value)}
                                                                rows="3"
                                                                className={`form-control `}
                                                                placeholder=" Please Enter Breif Descripition   "
                                                            />
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {/* Inspection Required Checkbox */}
                                <div className="form-check me-auto">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="inspectionRequired"
                                        checked={inspectionRequired === 1}
                                        onChange={(e) => setInspectionRequired(e.target.checked ? 1 : 0)}
                                    />
                                    <label className="form-check-label" htmlFor="inspectionRequired">
                                        Inspection Required
                                    </label>
                                </div>

                                {/* Close Button */}
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    data-bs-dismiss="modal"
                                    onClick={() => resetForm()}
                                >
                                    Close
                                </button>

                                {/* Submit Button */}
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={
                                        !submittalDescription ||
                                        !item_row ||
                                        !briefDescription ||
                                        !consultantId
                                    }
                                    onClick={handleSubmit}
                                >
                                    Submit Request
                                    <i className="ri-save-line label-icon align-middle fs-16 ms-2"></i>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AllItemRequests